import { render } from "./StorefrontSearchBox.vue?vue&type=template&id=6b5690b4&scoped=true"
import script from "./StorefrontSearchBox.vue?vue&type=script&lang=js"
export * from "./StorefrontSearchBox.vue?vue&type=script&lang=js"

import "./StorefrontSearchBox.vue?vue&type=style&index=0&id=6b5690b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5690b4"]])

export default __exports__